import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LogOut, User, Settings, Menu, X } from 'lucide-react';
import { useState } from 'react';
import logo from '../../assets/images/logo.png';

const Navbar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <nav className="bg-white shadow-md">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <Link to="/" className="flex items-center gap-2">
                        <img
                            src={logo}
                            alt="STEM4KIDDO"
                            className="h-12 w-auto"
                        />
                    </Link>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center gap-6">
                        {user ? (
                            <>
                <span className="text-gray-700">
                  Welcome, <strong>{user.full_name}</strong>
                </span>

                                <div className="flex items-center gap-2">
                                    {/*<Link*/}
                                    {/*    to="/profile"*/}
                                    {/*    className="p-2 hover:bg-gray-100 rounded-lg transition-colors"*/}
                                    {/*>*/}
                                    {/*    <Settings className="w-5 h-5 text-gray-600" />*/}
                                    {/*</Link>*/}

                                    <button
                                        onClick={handleLogout}
                                        className="flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                                    >
                                        <LogOut className="w-5 h-5" />
                                        Logout
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                {/*<Link to="/pricing" className="text-gray-700 hover:text-purple-600">*/}
                                {/*    Pricing*/}
                                {/*</Link>*/}
                                <Link to="/login" className="text-gray-700 hover:text-purple-600">
                                    Login
                                </Link>
                                <Link to="/login" className="btn-primary">
                                    Get Started
                                </Link>
                            </>
                        )}
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="md:hidden p-2 hover:bg-gray-100 rounded-lg"
                    >
                        {mobileMenuOpen ? (
                            <X className="w-6 h-6" />
                        ) : (
                            <Menu className="w-6 h-6" />
                        )}
                    </button>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="md:hidden py-4 border-t">
                        {user ? (
                            <div className="space-y-2">
                                <p className="px-4 py-2 text-gray-700">
                                    Welcome, <strong>{user.full_name}</strong>
                                </p>
                                <Link
                                    to="/profile"
                                    className="block px-4 py-2 hover:bg-gray-100 rounded-lg"
                                >
                                    Profile Settings
                                </Link>
                                <button
                                    onClick={handleLogout}
                                    className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg"
                                >
                                    Logout
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-2">
                                <Link
                                    to="/pricing"
                                    className="block px-4 py-2 hover:bg-gray-100 rounded-lg"
                                >
                                    Pricing
                                </Link>
                                <Link
                                    to="/login"
                                    className="block px-4 py-2 hover:bg-gray-100 rounded-lg"
                                >
                                    Login
                                </Link>
                                <Link
                                    to="/register"
                                    className="block px-4 py-2 bg-purple-600 text-white rounded-lg text-center"
                                >
                                    Get Started
                                </Link>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;